import { MaintenanceForwardingsEstablishmentChoiceEntryStepOptions } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/constants/maintenanceForwardingsShowDirectiveDetails.type'
import { useForwardingTabContext } from '@/features/maintenanceWorkflow/pages/Show/hooks/forwardings/useForwardingTabContext'
import MaintenanceWorkflowForwardingEstablishmentChoiceEntrySectionAuctionEntry from './Entries/AuctionEntry'
import MaintenanceWorkflowForwardingEstablishmentChoiceEntrySectionManualEntry, { MaintenanceWorkflowForwardingEstablishmentChoiceEntrySectionManualEntryProps } from './Entries/ManualEntry'

interface MaintenanceWorkflowForwardingEstablishmentChoiceEntrySectionProps {
  manualEntryProps?: MaintenanceWorkflowForwardingEstablishmentChoiceEntrySectionManualEntryProps
  showProposalDiagnostic?: boolean
}

const MaintenanceWorkflowForwardingEstablishmentChoiceEntrySection = ({
  manualEntryProps,
  showProposalDiagnostic,
}: MaintenanceWorkflowForwardingEstablishmentChoiceEntrySectionProps) => {
  const { forwarding } = useForwardingTabContext()

  if (forwarding.establishment_choice_entry_type === MaintenanceForwardingsEstablishmentChoiceEntryStepOptions.ManualEntry) {
    return (
      <MaintenanceWorkflowForwardingEstablishmentChoiceEntrySectionManualEntry {...manualEntryProps} showProposalDiagnostic={showProposalDiagnostic} />
    )
  }

  if (forwarding.establishment_choice_entry_type === MaintenanceForwardingsEstablishmentChoiceEntryStepOptions.AuctionEntry) {
    return (
      <MaintenanceWorkflowForwardingEstablishmentChoiceEntrySectionAuctionEntry />
    )
  }

  return null
}

export default MaintenanceWorkflowForwardingEstablishmentChoiceEntrySection
